import { render, staticRenderFns } from "./reqpurchase.vue?vue&type=template&id=23cb67c4&scoped=true"
import script from "./reqpurchase.vue?vue&type=script&lang=js"
export * from "./reqpurchase.vue?vue&type=script&lang=js"
import style0 from "./reqpurchase.vue?vue&type=style&index=0&id=23cb67c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb67c4",
  null
  
)

export default component.exports